export default [
  {
    path: '/futures',
    component: () => import('@/layout/index'),
    children: [
      {
        path: 'world-cup',
        name: 'world-cup',
				component: () => import('@/pages/v2/worldCup/container'),
        meta: {
          title: {
            zh_CN: '世界杯竞猜',
            zh_TW: '世界盃競猜',
            en_US: 'World Cup Prediction',
            ko_KR: '월드컵 예측',
            pt_BR: 'Palpite da Copa do Mundo',
            ja_JP: 'ワールドカップ予想',
            vi_VN: 'Dự đoán World Cup',
            id_ID: 'Prediksi Piala Dunia',
            tr_TR: 'Dünya Kupası Tahmini',
          },
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/router/v2/worldCup/index.js